//@flow
export default Marionette.View.extend({
    className: 'btn-separator',

    template: _.noop,
});
